import { useQuery } from "@tanstack/react-query";
import { getAllDevicesBasic } from "../services/deviceService";

export default function useBasicDevices() {
  const {
    data = [],
    isLoading,
    error
  } = useQuery(['devices', 'basic'], getAllDevicesBasic, {
    staleTime: 600_000
  });

  return {
    devices: data,
    loading: isLoading,
    error
  };
}
